import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pega-pin",
  "use": "pega-pin-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pega-pin\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M24.4 17.7l-2.2-4-.7-8.3 2.2-3.9a1 1 0 000-1c-.3-.3-.6-.5-1-.5H9.3c-.4 0-.7.2-.9.5s-.2.7 0 1l2.2 3.9-.8 8.3-2.3 4c-.3.5-.1 1.1.4 1.4l.4.1H15V31a1 1 0 002 0V19.2h6.5c.6 0 1-.5 1-1.1l-.1-.4zm-14.1-.5l1.5-2.7.1-.4.8-8.9-.1-.5L11 2h10l-1.5 2.7c-.1.2-.2.4-.1.6l.8 8.8.1.4 1.5 2.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol